module.exports = __webpack_public_path__ + "img/title4.c6a97739.png";